import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminLogin, setAdminAuthData } from '../../services/authService';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      toast.error('Please fill in all fields');
      return;
    }

    if (!formData.email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      const response = await adminLogin(formData);

      if (response.status === true) {
        
        setAdminAuthData({
          token: response.data.token,
          user: response.data.user
        });
        
        toast.success('Login successful!');
     
        navigate('/admin/dashboard');
      } else {
 
        toast.error(response.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
    
      if (error.response?.data) {
       
        const errorData = error.response.data;
        if (errorData.message) {
          toast.error(errorData.message);
        } else if (errorData.status === false && errorData.message) {
          toast.error(errorData.message);
        } else {
          toast.error('Login failed. Please try again.');
        }
      } else if (error.code === 'ERR_NETWORK') {
        toast.error('Network error. Please check your connection.');
      } else if (error.status === false && error.message) {
       
        toast.error(error.message);
      } else {
        toast.error('Login failed. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <main className="login">
        <div
          className="login-left right"
          style={{
            backgroundImage: `url(${window.getPublicUrl('admin/images/login-right-img.png')})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
          }}
        ></div>
        <div className="login-left">
          <div className="login-left-inner">
            <div className="logi-logo">
              <img src={window.getPublicUrl('admin/images/logo.svg')} alt="logo" />
            </div>
            <div className="login-mid">
              <h3>Login</h3>
              <p>Please enter your admin credentials below.</p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    aria-describedby="emailHelp"
                    disabled={isLoading}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    disabled={isLoading}
                    required
                  />
                  <span 
                    className="pass-show" 
                    onClick={togglePasswordVisibility}
                    style={{ cursor: 'pointer' }}
                  >
                    <img 
                      src={showPassword ? window.getPublicUrl("admin/images/Eye.svg") : window.getPublicUrl("admin/images/show-pass.svg")} 
                      alt={showPassword ? "Hide password" : "Show password"} 
                    />
                  </span>
                </div>
                <div className="form-group form-check">
                  <Link to="/admin/forgotPassword" className="forgot">
                    Forgot Password?
                  </Link>
                </div>
                <button 
                  type="submit" 
                  className="btn"
                  disabled={isLoading}
                >
                  {isLoading ? 'Logging in...' : 'Login'}
                </button>
              </form>
            </div>

            <h4>
              Don't have access? <a href="mailto:admin@roam4less.com">Contact Super Admin.</a>
            </h4>
          </div>
        </div>
      </main>
    </>
  );
}

export default Login;
